
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kalyanitomumbaicabs() {



    const cardData =
    {
        keyword: ' Kalyani Nagar to Mumbai Taxi',
        heading: 'Skyline Cabs: Kalyani Nagar to Mumbai Taxi',
        headingDescription: 'Skyline Cabs offers reliable and convenient Kalyani Nagar to Mumbai Taxi services. Whether you are traveling for business, leisure, or need an airport transfer, our fleet of well-maintained vehicles and professional drivers ensure a smooth and timely journey. With affordable rates, excellent customer support, and a focus on comfort and safety, Skyline Cabs makes your travel from Kalyani Nagar to Mumbai hassle-free. Book your Kalyani Nagar to Mumbai taxi today and enjoy a stress-free, comfortable ride.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Kalyani Nagar to Mumbai Taxi Fare",
      "description": "Skyline Cabs offers affordable and transparent fare pricing for taxis from Kalyani Nagar to Mumbai. Our competitive rates ensure a comfortable and reliable journey to your destination."
    },
    {
      "name": "Kalyani Nagar to Mumbai Airport Cab",
      "description": "Book a cab with Skyline Cabs for a hassle-free ride from Kalyani Nagar to Mumbai Airport. We offer timely service and a range of vehicle options including Innova and Ertiga for your convenience."
    },
    {
      "name": "Kalyani Nagar to Dadar Cab",
      "description": "Skyline Cabs offers comfortable and reliable cab services from Kalyani Nagar to Dadar. Choose from a variety of vehicles like Innova or Ertiga for a smooth and timely ride."
    },
    {
      "name": "Kalyani Nagar to Mumbai International Airport Cab",
      "description": "Travel with ease and comfort from Kalyani Nagar to Mumbai International Airport with Skyline Cabs. We provide a range of vehicles including Innova and Ertiga for a smooth journey to the airport."
    },
    {
      "name": "Kalyani Nagar to Mumbai One Day Cab",
      "description": "Skyline Cabs offers one-day cab services from Kalyani Nagar to Mumbai. Enjoy a full-day ride with professional drivers and flexible options, including one-way and round-trip bookings."
    },
    {
      "name": "Kalyani Nagar to Mumbai Airport Drop Cab",
      "description": "For a seamless ride from Kalyani Nagar to Mumbai Airport, book an airport drop cab with Skyline Cabs. Our fleet includes vehicles like Innova and Ertiga for a comfortable journey."
    },
    {
      "name": "Kalyani Nagar to Mumbai Drop Cab",
      "description": "Skyline Cabs offers reliable and timely drop-off services from Kalyani Nagar to Mumbai. Choose from a range of vehicles, including luxury options like the Innova for your comfort."
    },
    {
      "name": "Taxi Service in Kalyani Nagar Pune",
      "description": "Skyline Cabs offers efficient and reliable taxi services in Kalyani Nagar, Pune. Whether you're traveling locally or to Mumbai, we provide a variety of vehicle options for a comfortable ride."
    },
    {
      "name": "Cab Service in Kalyani Nagar",
      "description": "Skyline Cabs offers prompt and professional cab services in Kalyani Nagar, Pune. Our fleet includes a variety of vehicles, ensuring a safe and comfortable ride to your desired destination."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers convenient and affordable taxi services from Pune to Mumbai Airport. Choose from various vehicles like the Innova and Ertiga for a smooth and timely ride."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Travel comfortably from Pune to Mumbai with Skyline Cabs in an Ertiga. Ideal for families and small groups, the Ertiga provides ample space and a smooth journey at affordable rates."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs offers premium Innova cabs for a comfortable ride from Pune to Mumbai. Whether you're traveling for business or leisure, the Innova ensures a spacious and luxurious journey."
    },
    {
      "name": "Kalyani Nagar to Mumbai Airport Cabs",
      "description": "Skyline Cabs offers prompt and reliable airport transfer services from Kalyani Nagar to Mumbai Airport. Our experienced drivers and well-maintained vehicles ensure you reach the airport on time and with comfort."
    },
    {
      "name": "Wadgaon Sheri to Mumbai Cabs",
      "description": "Skyline Cabs provides reliable and affordable cab services from Wadgaon Sheri to Mumbai. Choose from various vehicles like Innova and Ertiga for a smooth, hassle-free ride."
    },
    {
      "name": "Cab Service in Kalyani Nagar",
      "description": "Skyline Cabs offers reliable taxi services in Kalyani Nagar, Pune. Whether it's a local trip or a long-distance journey, we ensure comfort, punctuality, and safety during your ride."
    },
    {
      "name": "Car Rental Service in Kalyani Nagar",
      "description": "Skyline Cabs offers flexible car rental services in Kalyani Nagar, Pune. Rent a car for a day or longer, with options including luxury and standard vehicles like the Innova or Ertiga."
    },
    {
      "name": "Cab Service in Yerwada",
      "description": "Skyline Cabs provides convenient and reliable taxi services in Yerwada, Pune. Whether you're heading to Mumbai or traveling locally, our fleet of vehicles ensures a comfortable and timely journey."
    },
    {
      "name": "Pune Mumbai Skyline Cabs",
      "description": "Skyline Cabs offers seamless and reliable taxi services between Pune and Mumbai. Whether you're looking for an airport transfer or a day trip, we provide high-quality vehicles for a safe and comfortable journey."
    }
  ],
  "tableData": [
    ["Kalyani Nagar to Mumbai Taxi Fare", "Kalyani Nagar to Mumbai Airport Cab"],
    ["Kalyani Nagar to Dadar Cab", "Kalyani Nagar to Mumbai International Airport Cab"],
    ["Kalyani Nagar to Mumbai One Day Cab", "Kalyani Nagar to Mumbai Airport Drop Cab"],
    ["Kalyani Nagar to Mumbai Drop Cab", "Taxi Service in Kalyani Nagar Pune"],
    ["Cab Service in Kalyani Nagar", "Pune to Mumbai Airport Cab"],
    ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Innova Cab"],
    ["Kalyani Nagar to Mumbai Airport Cabs", "Wadgaon Sheri to Mumbai Cabs"],
    ["Cab Service in Kalyani Nagar", "Car Rental Service in Kalyani Nagar"],
    ["Cab Service in Yerwada", "Pune Mumbai Skyline Cabs"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Kalyani Nagar to Mumbai Taxi Service",
        "WhyChoosedescription": "Skyline Cabs provides dependable and on-time taxi services from Kalyani Nagar to Mumbai. Whether it’s for a business meeting, a flight, or leisure, you can count on us to get you to your destination on schedule, every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in comfort with Skyline Cabs' well-maintained fleet of vehicles. From economy sedans to luxury cars, each vehicle is spacious, clean, and equipped with air-conditioning to ensure a comfortable ride from Kalyani Nagar to Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are not only knowledgeable about the best routes but are also courteous, professional, and committed to making your journey safe and pleasant. They are well-trained to handle traffic conditions on the Kalyani Nagar to Mumbai route."
    },
    {
        "WhyChooseheading": "Affordable Pricing with Transparent Fares",
        "WhyChoosedescription": "Skyline Cabs offers clear and upfront pricing for your Kalyani Nagar to Mumbai trip, ensuring you know exactly what to expect. No hidden charges, no surprises—just affordable and honest fares for your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel",
        "WhyChoosedescription": "Whether you need a taxi early in the morning or late at night, Skyline Cabs is available 24/7. You can book a ride from Kalyani Nagar to Mumbai at any time, and we’ll make sure your journey is as smooth as possible."
    },
    {
        "WhyChooseheading": "Diverse Vehicle Options for Every Traveler",
        "WhyChoosedescription": "Choose from a variety of vehicles that suit your travel style and group size. Whether you’re traveling alone or with a group, we have hatchbacks, sedans, SUVs, and luxury vehicles, all maintained to the highest standards of cleanliness and comfort."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking a taxi from Kalyani Nagar to Mumbai is quick and easy with Skyline Cabs. Our website and mobile app allow you to book a ride in just a few clicks, receive instant confirmation, and even track your driver in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are GPS-enabled for real-time tracking, and our drivers are background-checked for your peace of mind. Whether you’re traveling for business or leisure, enjoy a secure and stress-free journey from Kalyani Nagar to Mumbai."
    }
]











    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a taxi from Kalyani Nagar to Mumbai with Skyline Cabs?',
            answer:
                'Booking a taxi is easy with Skyline Cabs! You can book directly through our website, mobile app, or by calling our customer service. Enter your pickup location in Kalyani Nagar and drop-off in Mumbai, choose your vehicle, and confirm your booking in minutes.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Kalyani Nagar to Mumbai travel?',
            answer:
                'We offer a wide variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether you’re traveling solo, with family, or in a group, we have a vehicle that fits your needs.',
        },
        {
            id: 3,
            question: 'Is the fare from Kalyani Nagar to Mumbai fixed or based on distance?',
            answer:
                'Skyline Cabs offers fixed pricing for the Kalyani Nagar to Mumbai route. The fare includes all tolls, taxes, and any additional charges, which are shared upfront during booking.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip taxi from Kalyani Nagar to Mumbai?',
            answer:
                'Yes, you can book either a one-way or round-trip taxi, depending on your needs. Select the type of ride when booking, and we’ll handle the rest.',
        },
        {
            id: 5,
            question: 'How long does the journey from Kalyani Nagar to Mumbai take?',
            answer:
                'The journey usually takes around 3 to 3.5 hours, depending on traffic. Our experienced drivers ensure a smooth, comfortable, and timely arrival.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced and reliable?',
            answer:
                'Yes, all of our drivers are experienced, background-verified, and trained for long-distance travel. They are knowledgeable about the route and prioritize your safety and comfort.',
        },
        {
            id: 7,
            question: 'Can I schedule my taxi in advance for Kalyani Nagar to Mumbai?',
            answer:
                'Yes, you can schedule your ride in advance via our app or website. We recommend booking early, especially during peak hours or weekends, to ensure vehicle availability.',
        },
        {
            id: 8,
            question: 'Do you provide airport drop-off services from Kalyani Nagar to Mumbai?',
            answer:
                'Yes, we offer convenient airport taxi services from Kalyani Nagar to Mumbai Domestic and International Airports. Simply provide us with your flight details, and we’ll ensure a timely drop-off.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Kalyani Nagar to Mumbai taxi booking?',
            answer:
                'Yes, you can modify or cancel your booking easily through our app or website. Our customer service team is also available to assist you with changes if needed.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Kalyani Nagar to Mumbai taxi ride?',
            answer:
                'Skyline Cabs guarantees a smooth, reliable, and affordable taxi experience. We offer transparent pricing, comfortable vehicles, and well-trained drivers to ensure a stress-free journey from Kalyani Nagar to Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sanjay Mehta",
            rating: 5,
            review: "I had a fantastic experience booking a taxi from Kalyani Nagar to Mumbai with Skyline Cabs. The driver was on time, the car was in great condition, and the journey was smooth. Highly recommend their services!"
        },
        {
            name: "Miss. Anjali Kapoor",
            rating: 4,
            review: "The service was good, and I felt safe throughout the trip. The driver was friendly and professional. I would suggest having better in-car entertainment for long trips, but everything else was great!"
        },
    ];
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kalyani Nagar to Mumbai Taxi Service",
  "image": "https://skylinecabs.com/assets/images/kalyani-nagar-to-mumbai-taxi.jpg",
  "description": "Book Kalyani Nagar to Mumbai taxi service with Skyline Cabs for smooth and reliable travel. Choose from AC sedans and SUVs with professional drivers, available 24/7 at competitive fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7521"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kalyani-nagar-to-mumbai-taxi-service"
  }
};



      
     

    return (
        <div>

<Helmet>
  <title>Kalyani Nagar to Mumbai Taxi Service | AC Cab & SUV | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kalyani Nagar to Mumbai taxi service with Skyline Cabs for smooth and reliable travel. Choose from AC sedans and SUVs with professional drivers, available 24/7 at competitive fares." 
  />
  <meta 
    name="keywords" 
    content="Kalyani Nagar to Mumbai Taxi Service, Cab from Kalyani Nagar to Mumbai, One-Way Taxi Kalyani Nagar to Mumbai, Round Trip Cab Kalyani Nagar Mumbai, AC Cab Kalyani Nagar to Mumbai, SUV Taxi Kalyani Nagar to Mumbai, 24/7 Cab Booking Kalyani Nagar Mumbai, Skyline Cabs Kalyani Nagar to Mumbai, Affordable Taxi Kalyani Nagar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kalyanitomumbaicabs;